/** Havjoy Design System v1.1 commerce demos. Local mock state only. */
(() => {
  'use strict';
  const money = (n) => `$${Number(n).toFixed(2)}`;
  const one = (root, selector) => root.querySelector(selector);
  const all = (root, selector) => [...root.querySelectorAll(selector)];

  function dropdown(root, status) {
    const trigger = one(root, '[data-hj-demo-dropdown-trigger]');
    const menu = one(root, '[data-hj-demo-dropdown-menu]');
    const value = one(root, '[data-hj-demo-dropdown-value]');
    const options = all(root, '[data-hj-demo-dropdown-option]:not(:disabled)');
    const label = (option) => option.childNodes[0].textContent.trim();
    const setOpen = (open, focusOption = false) => {
      menu.hidden = !open;
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && focusOption) {
        const selected = options.find((option) => option.getAttribute('aria-selected') === 'true') || options[0];
        selected.focus();
      }
    };
    const choose = (option) => {
      options.forEach((item) => item.setAttribute('aria-selected', item === option ? 'true' : 'false'));
      value.textContent = label(option);
      setOpen(false);
      trigger.focus();
      status.textContent = `Finish ${label(option)} selected.`;
    };

    trigger.addEventListener('click', () => setOpen(menu.hidden, menu.hidden));
    trigger.addEventListener('keydown', (event) => {
      if (['ArrowDown', 'ArrowUp'].includes(event.key)) {
        event.preventDefault();
        setOpen(true, true);
      }
      if (event.key === 'Escape') setOpen(false);
    });
    options.forEach((option) => option.addEventListener('click', () => choose(option)));
    menu.addEventListener('keydown', (event) => {
      const index = options.indexOf(document.activeElement);
      if (event.key === 'Escape') { event.preventDefault(); setOpen(false); trigger.focus(); return; }
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); if (index >= 0) choose(options[index]); return; }
      if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      let next = index;
      if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = options.length - 1;
      else if (event.key === 'ArrowDown') next = (index + 1) % options.length;
      else next = (index - 1 + options.length) % options.length;
      options[next].focus();
    });
    document.addEventListener('click', (event) => { if (!root.contains(event.target)) setOpen(false); });
  }

  function product(root) {
    let qty = 1;
    let unit = 39.95;
    const status = one(root, '[data-hj-demo-product-status]');
    const atc = one(root, '[data-hj-demo-atc]');
    const render = () => {
      one(root, '[data-hj-demo-product-price]').textContent = money(unit);
      one(root, '[data-hj-demo-atc-price]').textContent = money(unit * qty);
      one(root, '[data-hj-demo-qty-output]').textContent = qty;
    };
    all(root, '[data-hj-demo-option]').forEach((button) => button.addEventListener('click', () => {
      all(root, `[data-hj-demo-option][data-group="${button.dataset.group}"]`).forEach((item) => {
        item.classList.toggle('is-selected', item === button);
        item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
      });
      if (button.dataset.price) unit = Number(button.dataset.price);
      if (button.dataset.label) one(root, '[data-hj-demo-product-type]').textContent = button.dataset.label;
      status.textContent = `${button.getAttribute('aria-label') || button.textContent.trim()} selected.`;
      render();
    }));
    all(root, '[data-hj-demo-qty]').forEach((button) => button.addEventListener('click', () => {
      qty = button.dataset.hjDemoQty === 'inc' ? Math.min(9, qty + 1) : Math.max(1, qty - 1);
      status.textContent = `Quantity ${qty}.`;
      render();
    }));
    atc.addEventListener('click', () => {
      atc.disabled = true;
      atc.dataset.state = 'loading';
      atc.firstChild.textContent = 'Adding mock item… ';
      status.textContent = 'Loading. No cart request is being made.';
      window.setTimeout(() => {
        atc.dataset.state = 'success';
        atc.firstChild.textContent = 'Added to demo ✓ ';
        status.textContent = 'Success. Your real cart was not changed.';
        window.setTimeout(() => {
          atc.disabled = false;
          atc.dataset.state = 'idle';
          atc.firstChild.textContent = 'Add to cart · ';
        }, 1400);
      }, 700);
    });
    all(root, '[data-hj-demo-dropdown]').forEach((item) => dropdown(item, status));
    render();
  }

  function personalize(root) {
    let timer;
    const status = one(root, '[data-hj-demo-personalize-status]');
    const required = one(root, '[data-hj-demo-required]');
    const field = required.closest('.hj__personalize-field');
    const error = one(root, '[data-hj-demo-field-error]');
    const processing = one(root, '[data-hj-demo-processing]');
    const result = one(root, '[data-hj-demo-preview-result]');
    const go = (step) => {
      window.clearTimeout(timer);
      all(root, '[data-hj-demo-stage]').forEach((stage) => { stage.hidden = Number(stage.dataset.hjDemoStage) !== step; });
      all(root, '[data-hj-demo-personalize-step]').forEach((item, index) => {
        item.classList.toggle('is-active', index + 1 === step);
        item.classList.toggle('is-complete', index + 1 < step);
      });
      if (step === 3) {
        processing.hidden = false;
        result.hidden = true;
        status.textContent = 'Preview processing started.';
        timer = window.setTimeout(() => {
          processing.hidden = true;
          result.hidden = false;
          one(result, '[data-hj-demo-approve]').focus();
          status.textContent = 'Preview ready for review and approval.';
        }, 900);
      }
    };
    one(root, '[data-hj-demo-upload]').addEventListener('click', () => {
      one(root, '[data-hj-demo-thumbs]').hidden = false;
      status.textContent = 'Two mock photos uploaded.';
      window.setTimeout(() => go(2), 450);
    });
    all(root, '[data-hj-demo-remove-photo]').forEach((button) => button.addEventListener('click', () => {
      button.closest('.hj__personalize-thumb').remove();
      status.textContent = 'Photo removed. You can re-upload.';
    }));
    one(root, '[data-hj-demo-personalize-back]').addEventListener('click', () => go(1));
    one(root, '[data-hj-demo-preview]').addEventListener('click', () => {
      const invalid = !required.value.trim();
      field.classList.toggle('is-error', invalid);
      error.hidden = !invalid;
      required.setAttribute('aria-invalid', invalid ? 'true' : 'false');
      if (invalid) { status.textContent = 'Please correct the required field.'; required.focus(); return; }
      go(3);
    });
    one(root, '[data-hj-demo-edit]').addEventListener('click', () => go(2));
    one(root, '[data-hj-demo-regenerate]').addEventListener('click', () => go(3));
    one(root, '[data-hj-demo-restart]').addEventListener('click', () => { required.value = ''; go(1); status.textContent = 'Personalization reset.'; });
    one(root, '[data-hj-demo-approve]').addEventListener('click', (event) => {
      event.currentTarget.textContent = 'Design approved ✓';
      event.currentTarget.disabled = true;
      status.textContent = 'Design approved before purchase.';
    });
  }

  function bundle(root) {
    const offers = all(root, '[data-hj-demo-offer]');
    const render = () => {
      const selected = offers.filter((offer) => offer.classList.contains('is-selected'));
      const raw = selected.reduce((sum, offer) => sum + Number(offer.dataset.price), 0);
      const rate = selected.length >= 2 ? 0.15 : 0;
      const saving = raw * rate;
      one(root, '[data-hj-demo-bundle-count]').textContent = `${selected.length} ${selected.length === 1 ? 'item' : 'items'}`;
      one(root, '[data-hj-demo-bundle-saving]').textContent = `Save ${money(saving)}`;
      one(root, '[data-hj-demo-bundle-total]').textContent = money(raw - saving);
      one(root, '[data-hj-demo-bundle-threshold]').textContent = rate ? '15% bundle discount unlocked' : 'Add 1 for 15% off';
      one(root, '[data-hj-demo-bundle-slot]').classList.toggle('is-filled', selected.length > 1);
      one(root, '[data-hj-demo-bundle-status]').textContent = rate ? 'Bundle complete. Mock totals recalculated.' : 'Bundle incomplete — add an offer to unlock savings.';
    };
    offers.forEach((offer, index) => offer.addEventListener('click', () => {
      if (index === 0) return;
      offer.classList.toggle('is-selected');
      offer.setAttribute('aria-pressed', offer.classList.contains('is-selected') ? 'true' : 'false');
      render();
    }));
    render();
  }

  function cart(root) {
    let qty = 1;
    let discount = 0;
    const unit = 39.95;
    const body = one(root, '[data-hj-demo-cart-body]');
    const empty = one(root, '[data-hj-demo-cart-empty]');
    const status = one(root, '[data-hj-demo-cart-status]');
    const error = one(root, '[data-hj-demo-cart-error]');
    const render = () => {
      const subtotal = unit * qty;
      const saving = subtotal * discount;
      one(root, '[data-hj-demo-cart-count]').textContent = `${qty} ${qty === 1 ? 'item' : 'items'}`;
      one(root, '[data-hj-demo-cart-qty-output]').textContent = qty;
      one(root, '[data-hj-demo-cart-item-price]').textContent = money(subtotal);
      one(root, '[data-hj-demo-cart-subtotal]').textContent = money(subtotal);
      one(root, '[data-hj-demo-cart-saving]').textContent = `−${money(saving)}`;
      one(root, '[data-hj-demo-cart-total]').textContent = money(subtotal - saving);
      const remaining = Math.max(0, 60 - subtotal);
      one(root, '[data-hj-demo-cart-progress-copy]').textContent = remaining ? `Add ${money(remaining)} for volume savings` : 'Volume savings unlocked';
      one(root, '[data-hj-demo-cart-progress-bar]').style.width = `${Math.min(100, subtotal / 60 * 100)}%`;
    };
    all(root, '[data-hj-demo-cart-qty]').forEach((button) => button.addEventListener('click', () => {
      qty = button.dataset.hjDemoCartQty === 'inc' ? Math.min(9, qty + 1) : Math.max(1, qty - 1);
      status.textContent = `Mock cart quantity updated to ${qty}.`;
      render();
    }));
    one(root, '[data-hj-demo-discount-apply]').addEventListener('click', () => {
      const valid = one(root, '[data-hj-demo-discount-input]').value.trim().toUpperCase() === 'MOCK10';
      discount = valid ? 0.1 : 0;
      error.hidden = valid;
      status.textContent = valid ? 'Mock discount applied: 10%.' : 'Update error. Use MOCK10 or retry.';
      render();
    });
    one(root, '[data-hj-demo-cart-retry]').addEventListener('click', () => { error.hidden = true; status.textContent = 'Ready to retry.'; });
    one(root, '[data-hj-demo-edit-variant]').addEventListener('click', () => { status.textContent = 'Variant editor state would open here.'; });
    one(root, '[data-hj-demo-cart-remove]').addEventListener('click', () => { body.hidden = true; empty.hidden = false; one(root, '[data-hj-demo-cart-restore]').focus(); });
    one(root, '[data-hj-demo-cart-restore]').addEventListener('click', () => { empty.hidden = true; body.hidden = false; status.textContent = 'Mock item restored.'; render(); });
    one(root, '[data-hj-demo-checkout]').addEventListener('click', () => { status.textContent = 'Checkout handoff preview only. No navigation or request occurred.'; });
    render();
  }

  function order(root) {
    const labels = ['Order Received', 'Awaiting Production', 'In Production', 'Shipped', 'Delivered'];
    const buttons = all(root, '[data-hj-demo-order-state]');
    const steps = all(root, '[data-hj-demo-order-step]');
    const pill = one(root, '[data-hj-demo-order-pill]');
    const tracking = one(root, '[data-hj-demo-order-tracking]');
    const edit = one(root, '[data-hj-demo-order-edit]');
    const address = one(root, '[data-hj-demo-order-address]');
    const note = one(root, '[data-hj-demo-order-note]');
    const render = (state) => {
      buttons.forEach((button, index) => { button.classList.toggle('is-selected', index === state); button.setAttribute('aria-pressed', index === state ? 'true' : 'false'); });
      steps.forEach((item, index) => { item.classList.toggle('is-complete', index < state); item.classList.toggle('is-current', index === state); });
      pill.textContent = labels[state];
      pill.className = `hj__pill hj__state-pill ${state >= 4 ? 'hj__state-pill--success' : state >= 3 ? 'hj__state-pill--info' : 'hj__state-pill--warning'}`;
      tracking.hidden = state < 3;
      edit.disabled = state >= 2;
      address.disabled = state >= 2;
      note.textContent = state < 2 ? 'Design, size, address and cancellation can still be requested.' : state < 3 ? 'Production has started. Contact support for changes.' : state < 4 ? 'Tracking is available. Production edits are closed.' : 'Delivered. Report an issue through support.';
    };
    buttons.forEach((button) => button.addEventListener('click', () => render(Number(button.dataset.hjDemoOrderState))));
    render(0);
  }

  const init = () => {
    document.querySelectorAll('[data-hj-demo-product]').forEach(product);
    document.querySelectorAll('[data-hj-demo-personalize]').forEach(personalize);
    document.querySelectorAll('[data-hj-demo-bundle]').forEach(bundle);
    document.querySelectorAll('[data-hj-demo-cart]').forEach(cart);
    document.querySelectorAll('[data-hj-demo-order]').forEach(order);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
